





















	import {
		format
	} from 'date-fns-jalali';
import { Instance } from '@/classes/TayehApi';
import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import { GetInstanceResponse, TimeScope } from '@/classes/TayehApi/Instance';
	@Component({
		components: {
			apexchart: () => import('vue-apexcharts')
		}
	})
	export default class ShopReportCost extends Vue {
		@Prop()
		title: string;

		@Inject()
		getInstance: () => GetInstanceResponse;

		period: [TimeScope, number] = [TimeScope.YEAR, 1];
		yearly_cost= 0;
		yearly_last_period_cost= 0;

		monthly_cost= 0;
		monthly_last_period_cost= 0;

		series= [0, 0];
		chartOptions= {
			chart: {
				type: 'radialBar',
				// fontFamily: 'IRANSans-fa'
			},
			stroke: {
				lineCap: 'round',
				width: 1,
			},
			colors: ['#0066ff', '#96c0ff'],
			plotOptions: {
				radialBar: {
					track: {
						background: '#fff',
						margin: 6,
					},
					dataLabels: {
						name: {
							fontSize: '12',
							offsetY: -15,
						},
						value: {
							fontSize: '14px',
							offsetY: -10,
						},
						total: {
							color: '#ddd',
							show: true,
							label: 'امروز',
							fontSize: '12px',
							formatter: function () {
								return format(new Date(), 'dd MMMM')
							}
						},
					},
				}
			},
			labels: ['هزینه سالیانه', 'هزینه ماهیانه'],
		};
		async getCost() {
			let res_yearly = await Instance.getInstanceStatsCost(this.getInstance().id, TimeScope.YEAR, 1);
			let res_monthly = await Instance.getInstanceStatsCost(this.getInstance().id, TimeScope.MONTH, 1);
			this.yearly_cost = res_yearly.data.cost;
			this.yearly_last_period_cost = res_yearly.data.last_period_cost;

			this.monthly_cost = res_monthly.data.cost;
			this.monthly_last_period_cost = res_monthly.data.last_period_cost;
			this.series = [
				this.yearly_last_period_cost===0?100:(this.yearly_cost-this.yearly_last_period_cost)*100/this.yearly_last_period_cost,//yearly series
				this.monthly_last_period_cost===0?100:(this.monthly_cost-this.monthly_last_period_cost)*100/this.monthly_last_period_cost,//monthly series
				]
			// this.series = typeof this.report === 'object'?[this.report.type_4, this.report.type_2]:[0,0]
		}
		mounted () {
			this.getCost()
			// if (typeof this.report === 'undefined') this.getReport();
		}
	}
